import { useCallback } from "react";
import useWeb3 from "../useWeb3";
import environment from "../../utils/Environment";
import { getGemsStakingContract } from "../../utils/contractHelpers";
import Web3 from "web3";
import Environment from "../../utils/Environment";

export const GetGemsStakedIndex = () => {
  // const web3 = useWeb3();
  const web3 = new Web3(Environment.rpc);
  const tokenAddress = environment.GemsStaking;
  const contract = getGemsStakingContract(tokenAddress, web3);
  const getGemsStakedIndex = useCallback(
    async (account) => {
      const index = await contract.methods
        .stakeIndex(account?.toString())
        .call();
      return index;
    },
    [contract],
  );

  return { getGemsStakedIndex: getGemsStakedIndex };
};

export default GetGemsStakedIndex;
